import React from 'react';
import styles from './styles.module.css';
import Image from 'next/image';

interface CommonItemProps {
  label: string;
  icon?: string;
}

export const CommonItem = ({ label, icon }: CommonItemProps) => {
  return (
    <div className={styles.itemContainer}>
      {icon && (
        <Image src={icon} alt={`${label} icon`} width={26} height={15} />
      )}
      <span className={styles.item_text}>{label}</span>
    </div>
  );
};
